import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-136">
      <div className="max-w-4xl mx-auto text-center" data-id="element-137">
        <div className="text-[#FF6B00] text-3xl font-black tracking-widest mb-8" data-id="element-138">
          🥁 PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-139">
          El próximo domingo podés seguir buscando en internet.
        </h2>
        <p className="text-[#FF6B00] text-2xl sm:text-3xl font-black mb-10" data-id="element-140">
          O podés tener todo resuelto desde hoy.
        </p>

        {/* Compact Cost Table */}
        <div className="bg-[#1a0d00] border border-[#FF6B00]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-141">
          <div className="p-3 bg-[#0d0600] border-b border-[#FF6B00]/30 text-center font-bold text-white text-sm" data-id="element-142">
            ¿Cuánto cuesta NO tenerlo?
          </div>
          {[['120 hs/año planificando desde cero', '10 min/semana. El resto es enseñar.'], ['Correcciones improvisadas → mismo error por meses', '120+ guiones exactos → se resuelve en la clase'], ['70% de abandono antes del año', 'Sistema de fidelización → retención +80%'], ['Sin material diferenciado por edad', '6 tomos con progresión → avanzan y recomiendan'], ['Actos de último momento sin sistema', 'Glosas + Guiones + Plan B listo en 48 horas'], ['La muestra organizada en caos', 'Sistema Muestra Sin Caos: 6 semanas + roles + día'], ['Sin identidad visual profesional', 'Identidad premium que justifica cobrar más'], ['Contratos verbales que terminan en conflicto', 'Kit completo de documentos legales firmados']].map(([without, withPack], i) => <div key={i} className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800 last:border-b-0" data-id="element-143">
              <div className="p-3 text-gray-400 text-xs sm:text-sm" data-id="element-144">
                {without}
              </div>
              <div className="p-3 text-white font-bold text-xs sm:text-sm bg-[#FF6B00]/5 sm:border-l border-gray-800" data-id="element-145">
                {withPack}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-146">
          <p className="text-white font-bold mb-4" data-id="element-147">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-148" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-149">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-150">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-151">
          <div className="bg-[#0a0a0a] border border-[#FF6B00]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-152">
            <div className="text-2xl mb-2" data-id="element-153">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-154">
              MEGAPACK FOLKLORE LISTO
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-155">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-156">
              <p className="text-[#FF6B00] text-2xl font-black mb-4" data-id="element-157">
                $19.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48178806096128:1" className="btn-green-pulse block bg-[#FF6B00] font-black py-4 rounded-lg hover:bg-[#FF8533] transition-colors text-sm text-[#FFFFFF]" data-id="element-158">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#0d0600] border-2 border-[#FF6B00] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(255,107,0,0.2)] flex flex-col" data-id="element-159">
            <div className="text-2xl mb-2" data-id="element-160">🏆</div>
            <h3 className="text-[#FF6B00] font-black mb-1" data-id="element-161">
              MEGAPACK + FOLKLORE PRO ELITE ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-162">
              6 Tomos + 6 Bonos + Folklore Pro Elite™
            </p>
            <div className="mt-auto" data-id="element-163">
              <p className="text-[#FF6B00] text-3xl font-black mb-4" data-id="element-164">
                $27.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48178807472384:1" className="btn-green-pulse block bg-[#FF6B00] font-black py-4 rounded-lg hover:bg-[#FF8533] transition-colors text-sm text-[#FFFFFF]" data-id="element-165">
                → QUIERO EL MEGAPACK + FOLKLORE PRO ELITE
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-166">
          <span data-id="element-167">🔒 Pago 100% seguro</span>
          <span data-id="element-168">⚡ Acceso en 5 minutos</span>
          <span data-id="element-169">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-170">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}